import { submitFeedback } from '@/entities/feedback-item';
export async function submitFeedbackAction(feedbackId, payload = {}) {
    await submitFeedback(feedbackId, payload);
}
